module.exports = __webpack_public_path__ + "img/Hard.f002fe61.png";